import { routes } from "src/shared/routes";
import {
  FAQS,
  FOOTER_LINKS,
  SWAF_INFO_TEXT,
  REGISTRATION_CARDS,
  TERMS_AND_CONDITION,
  CHECKOUT_TERMS_AND_CONDITION,
} from "./helper";
import { constants } from "src/shared/constants";

import desktopBannerImage from "public/images/gatorsstudents/gatorsstudents_desktop_banner.jpg";
import mobileBannerImage from "public/images/gatorsstudents/gatorsstudents_mobile.jpg";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const gators_sandbox: TTeamConfig = {
  TEAM_SCHEMA: "gators_sandbox",
  TEAM_FULL_NAME: "University of Florida",
  BROWSER_TITLE: "Florida Gators Student Tickets",
  CLIENT_ID: "0cc9a385a0f8.seasonshare.gators-gators.us",
  VENDOR: constants.vendorUUIDs.ticketmaster,

  TEAM_GLOBAL_SETTINGS: {
    ACCOUNT_MANAGER_URL: "https://am.ticketmaster.com/gators",
    COLORS_PRIMARY: "#0021A5",
    COLORS_SECONDARY: "#FA4616",
    DEFAULT_APP_ROUTE: routes.home,
    DEFAULT_APP_ROUTE_AFTER_LOGIN: routes.home,
    DISABLE_PASS_ON_ACCOUNT_RESTRICTION: true,
    IS_CROWD_HANDLER_ENABLED: true,

    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },

    FOOTER: {
      LINKS: FOOTER_LINKS,
    },

    IS_INTERCOM_ENABLED: true,
  },

  LANDING_PAGE_SETTINGS: {
    HIDE_PASSES: true,
    HIDE_UPCOMING_EVENTS: true,

    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
      HIDE_SECTION_TITLE: true,
    },

    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: false,
    },

    ZERO_STATE: {
      TITLE: " ",
      DESCRIPTION:
        "No events are currently available for purchase. Please check back later.",
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    HIDE_PASSES: true,
    HIDE_UPCOMING_EVENTS: true,

    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
    },
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <TERMS_AND_CONDITION />,
    },
  },

  MY_GROUP_PAGE_SETTINGS: {
    PAGE_INFO_TEXT: <SWAF_INFO_TEXT />,
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: true,
    },

    ADD_ONS_LABEL: "Tickets",
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  PURCHASE_HISTORY_PAGE_SETTINGS: {
    PURCHASE_HISTORY_ZERO_STATE: {
      TITLE: "No orders yet",
      DESCRIPTION: "Only purchases made on this platform will appear here.",
    },
  },

  IMAGES: {
    LOGO_URL: "https://ss-leagues.s3.amazonaws.com/NCAA/u-florida-gators.png",
    LANDING_PAGE_STATIC_BANNER_URL: desktopBannerImage.src,
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL: mobileBannerImage.src,
    GROUP_INVITE_PAGE_STATIC_BANNER_URL: desktopBannerImage.src,
    ORDER_SUMMERY_BACKGROUND_URL: desktopBannerImage.src,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION: CHECKOUT_TERMS_AND_CONDITION,
  },
};
